import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-with-response',
  standalone: true,
  imports: [MatButtonModule, CommonModule, TranslateModule],
  templateUrl: './modal-with-response.component.html',
  styleUrl: './modal-with-response.component.scss'
})
export class ModalWithResponseComponent {

  constructor(
    public dialogRef: MatDialogRef<ModalWithResponseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}


  closeModal() {
    this.dialogRef.close();
  }

  closeModalWithResult(result?: any) {
    this.dialogRef.close(result);
  }

  // Static method to open the modal (can be used from any component)
  static open(dialog: MatDialog, data: any) {
    return dialog.open(ModalWithResponseComponent, {
      width: data.width || '800px',
      data: data,
      disableClose: false,
      height: data.height || 'auto'
    });
  }

}
